import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ReviewQueueComponent } from '@brightnav/review';

/**
 * Review tab host — BrightNav client-information tab beside Profile and Finances.
 * The queue stays an internal implementation detail of this feature.
 */
@Component({
  selector: 'bn-review-tab',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReviewQueueComponent],
  template: `
    <div class="bn-review-tab">
      <bn-review-queue
        [clientGuid]="clientGuid()"
        [clientName]="clientName()"
        (defaultCountChange)="defaultCountChange.emit($event)"
      />
    </div>
  `,
})
export class ReviewTabComponent {
  readonly clientGuid = input.required<string>();
  readonly clientName = input<string | null>(null);
  readonly defaultCountChange = output<number>();
}
